import React, { Fragment, useEffect, useState } from "react";
import { useMediaQuery } from "@material-ui/core";
import { notBlank } from "../../util/ext";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";

import DatePicker from "./DatePicker";

const PublicationDate = props => {
  const {
    errors,
    handleBlur,
    isRequired,
    media,
    onCheckboxChange,
    onDateChange,
    onTextChange,
    validator,
  } = props;

  const isMid = useMediaQuery(theme => theme.breakpoints.up("mid"));

  const [fullDate, setFullDate] = useState(true);
  useEffect(() => {
    if (media.publicationDate?.split && notBlank(media.publicationDate)) {
      const [date] = media.publicationDate.split("T");
      const [_year, month, day] = date.split("-");
      const isJanFirst = month === "01" && day === "01";
      setFullDate(!isJanFirst);
    }
  }, [media]);

  return (
    <Fragment>
      <Grid item>
        <Box mt="24px">
          <Select
            value={fullDate ? "pd" : "py"}
            onChange={event => {
              const isFullDate = event.target.value === "pd";
              const field = isFullDate ? "publicationDate" : "publicationYear";

              setFullDate(isFullDate);
              onDateChange(field)("");
            }}
            inputProps={{
              name: "content-full-date-select",
              id: "content-full-date-select",
            }}
          >
            <MenuItem value={"py"}>
              {isMid ? "Publication Year" : "Pub. Year"}
            </MenuItem>
            <MenuItem value={"pd"}>
              {isMid ? "Publication Date" : "Pub. Date"}
            </MenuItem>
          </Select>
        </Box>
      </Grid>

      <Grid item xs style={{ paddingRight: 0 }}>
        <Box>
          {fullDate ? (
            <DatePicker
              noLabel
              placeholder="mm/dd/yyyy"
              required={isRequired("publicationDate")}
              value={media.publicationDate}
              onBlur={handleBlur("publicationDate")}
              onChange={onDateChange("publicationDate")}
              error={validator.hasError(errors, "publicationDate")}
              helperText={validator.firstError(errors, "publicationDate")}
            />
          ) : (
            <TextField
              id={`content-publication-year`}
              fullWidth
              required={isRequired("publicationYear")}
              placeholder="yyyy"
              value={
                media?.publicationYear ?? media.publicationDate?.slice(0, 4)
              }
              onChange={onTextChange(["publicationYear"])}
              onBlur={handleBlur("publicationYear")}
              error={validator.hasError(errors, "publicationYear")}
              helperText={validator.firstError(errors, "publicationYear")}
              inputProps={{
                maxLength: 4,
                inputMode: "numeric",
                pattern: "[0-9]{4}",
                style: { marginTop: 26 },
              }}
            />
          )}

          <FormControlLabel
            style={{ marginTop: 15, marginBottom: -15 }}
            control={
              <Checkbox
                color="primary"
                checked={media.publicationDateCirca}
                onChange={onCheckboxChange("publicationDateCirca")}
                name="content-publicationDateCirca"
                inputProps={{ "aria-label": "Select" }}
              />
            }
            label="Circa"
          />
        </Box>
      </Grid>
    </Fragment>
  );
};

export default PublicationDate;
